<template>
    <v-card flat>
        <v-card-text class="pl-0 pr-0 pb-0">
            <v-row class="mt-n5">
                <v-col>
                    <tile-search-date
                        init-type="WEEK"
                        @changed="searchDateChanged"
                        @inited="searchDateInited"
                        ref="date_range_select"
                        :from-day="searchParam.search_start"
                        :to-day="searchParam.search_end"
                    ></tile-search-date>
                </v-col>
                <v-col cols="2">
                    <v-select
                        class="text-h6"
                        single-line
                        :items="selTransResultItems"
                        v-model="searchParam.trans_result"
                        label="통화연결 선택"
                        item-text="txt"
                        item-value="val"
                    ></v-select>
                </v-col>
                <v-col cols="2">
                    <v-select
                        class="text-h6"
                        single-line
                        :items="selSearchTypeItems"
                        v-model="searchParam.search_type"
                        label="검색 유형을 선택해 주세요"
                        item-text="txt"
                        item-value="val"
                    ></v-select>
                </v-col>
                <v-col>
                    <v-text-field
                        class="text-h6"
                        v-model="searchParam.search_text"
                        @keyup.enter="doSearch(1)"
                    ></v-text-field>
                </v-col>
                <v-col class="d-flex align-center">
                    <tile-search-button @click="doSearch(1)" class="mx-2" style="float:left;"></tile-search-button>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="text-right mt-n5" style="font-size:20px; color:#555555;">통화량 : {{ this.$options.filters.number(totalCount) }} 건</v-col>
            </v-row>
            <v-card flat class="mt-4">
                <v-simple-table class="border-table">
                    <template v-slot:default>
                        <thead>
                        <tr style="background-color:#F4F6F8; height:39px; color:#333333; font-weight:600;">
                            <th rowspan="2" class="text-center text-h6 border-th-bottom">수신일시</th>
                            <th colspan="2" class="text-center text-h6 border-th-bottom">발신자</th>
                            <th rowspan="2" class="text-center text-h6 border-th-bottom">ARS메뉴</th>
                            <th rowspan="2" class="text-center text-h6 border-th-bottom">수신자</th>
                            <th rowspan="2" class="text-center text-h6 border-th-bottom">통화연결</th>
                            <th rowspan="2" class="text-center text-h6 border-th-bottom">통화시간</th>
                            <th rowspan="2" class="text-center text-h6 border-th-bottom" v-if="recordAccYn === 'Y'">녹취</th>
                        </tr>
                        <tr style="background-color:#F4F6F8; height:39px; color:#333333; font-weight:600;">
                            <th class="text-center text-h6">이름(표시명)</th>
                            <th class="text-center text-h6">발신번호</th>
                        </tr>
                        </thead>
                        <tbody style="color:#555555;">
                        <tr v-for="(statItem, statIdx) in statList" :key="statIdx" style="height:68px;">
                            <td class="text-center pl-6" style="font-size:20px;">{{ statItem.call_start_dt | dateMin }}</td>
                            <td class="text-center" style="font-size:20px;">
                                <template v-if="statItem.cust_name && statItem.cust_name.length !== 0">{{ statItem.cust_name }}</template>
                                <template v-else>
                                    <v-btn outlined color="primary" @click="popupAddrBook(statItem.caller_mdn)">연락처 등록</v-btn>
                                </template>
                                <v-btn outlined color="primary" @click="popupCustMemo(statItem)" class="ml-3">메모({{ statItem.memo_count | number }})</v-btn>
                            </td>
                            <td class="text-center" style="font-size:20px;">{{ statItem.caller_mdn | phoneNum }}</td>
                            <td class="text-center" style="font-size:20px;">{{ statItem.related_menu_name }}</td>
                            <td class="text-center" style="font-size:20px;">
                                {{ statItem.receiver_name }}
                                <v-chip 
                                    outlined 
                                    color="primary"
                                    medium
                                    class="ml-2" 
                                    style="cursor:pointer; border: 1.5px solid #1976d2; background-color: #f8fbff;" 
                                    v-if="statItem.trans_count > 1" 
                                    @click="openSvcCallListPopup(statItem)"
                                >
                                    <v-icon small class="mr-1" color="primary">mdi-account-multiple</v-icon>
                                    <span style="font-weight: 600; font-size: 13px; color: #1976d2;">{{ statItem.trans_count }}명</span>
                                </v-chip>
                            </td>
                            <td class="text-center" style="font-size:20px;">{{ transResultText(statItem) }}</td>
                            <td class="text-center pr-6" style="font-size:20px;">{{ Math.ceil(statItem.call_duration / 60) | number }} 분</td>
                            <td class="text-center pr-6" style="font-size:20px;" v-if="recordAccYn === 'Y'">
                                <v-btn small v-if="recordAccYn === 'Y' && statItem.record_yn === 'Y' && statItem.record_result === 'DONE' && statItem.record_cont_seqno > 0 && statItem.play_yn === 'Y'"
                                       @click="downloadRecord(statItem)" outlined color="green" style="font-weight: 600; font-size: 14px;">다운로드
                                </v-btn>
                                <span v-else>-</span>
                            </td>
                        </tr>
                        <tr style="height:69px;" v-if="!statList || statList.length === 0">
                            <td class="text-center" style="font-size:20px;" colspan="8">조회된 결과가 없습니다</td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card>
        </v-card-text>
        <v-row class="mt-4">
            <v-col cols="2" class="text-left">
                <v-btn v-on:click="downloadExcel" :loading="excelLoading">DOWNLOAD</v-btn>
            </v-col>
            <v-col cols="10" class="text-right">
                <tile-paging :pageNo="searchParam.page_no" :totalPageCount="totalPageCount" @goPage="doSearch"></tile-paging>
            </v-col>
        </v-row>
        <v-dialog v-model="modal" persistent max-width="900" @keydown.esc="closePopup()">
            <v-flex v-if="dialogMode === 'svc_call_list'">
                <popup-svc-call-list v-on:cancel="closePopup"></popup-svc-call-list>
            </v-flex>
        </v-dialog>
    </v-card>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import svcHistApi from '@/api/svc_hist'


export default {
    name: 'svc_hist_svc_list',
    components: {
        'TilePaging': () => import('@/components/common/tile_paging.vue'),
        'TileSearchDate': () => import('@/components/common/tile_search_date.vue'),
        'PopupSvcCallList': () => import('@/components/svc_hist/popup_svc_call_list.vue'),
        'TileSearchButton': () => import('@/components/common/tile_search_button.vue'),
    },
    data: () => ({
        searchParam: {
            search_start: '',
            search_end: '',
            trans_result: '',
            search_type: 'CALLER_MDN',
            search_text: '',
            page_no: 1,
            page_size: 10
        },
        selTransResultItems: [
            {txt: '통화결과: 전체', val: ''},
            {txt: '통화결과: 통화', val: 'SUCC'},
            {txt: '통화결과: 실패', val: 'FAIL'},
            {txt: '통화결과: 포기', val: 'ABORT'}
        ],
        selSearchTypeItems: [
            {txt: '검색유형: 발신번호', val: 'CALLER_MDN'},
            {txt: '검색유형: 발신자명', val: 'CUST_NAME'},
            {txt: '검색유형: ARS메뉴', val: 'RELATED_MENU_NAME'}
        ],
        modal: false,
        dialogMode: 'none',
        initFlags: {'search_date': false},
        excelLoading: false,
    }),
    created() {
        this.$store.commit('layoutFlag', true)
        this.$store.commit('menuId', 'svc_hist')

        let lastMenuId = this.$store.getters['lastMenuId']
        if (lastMenuId === 'svc_hist' && this.curSearchParam) {
            Object.assign(this.search, this.curSearchParam)
        }
    },
    computed: {
        ...mapGetters({
            recordAccYn: 'login/getRecordAccYn'
        }),
        ...mapState('svc_hist_svc', {
            curSearchParam: state => state.searchParam,
            totalCount: state => state.totalCount,
            statList: state => state.statList,
        }),
        totalPageCount() {
            if (this.totalCount === 0) {
                return 0
            }
            let pageSize = (this.searchParam && this.searchParam.page_size) ? this.searchParam.page_size : 25
            return Math.floor(this.totalCount / pageSize) + (((this.totalCount % pageSize) > 0) ? 1 : 0)
        },
        isLoaded() {
            return !!this.statList;
        }
    },
    methods: {
        searchDateInited(payload) {
            if (payload && payload.from_day) {
                this.searchParam.search_start = payload.from_day
            }
            if (payload && payload.to_day) {
                this.searchParam.search_end = payload.to_day
            }
            this.initFlags['search_date'] = true
            this.doSearch()
        },
        searchDateChanged(payload) {
            if (payload && payload.from_day) {
                this.searchParam.search_start = payload.from_day
            }
            if (payload && payload.to_day) {
                this.searchParam.search_end = payload.to_day
            }
        },
        doSearch(no) {
            if (no) {
                this.searchParam.page_no = no
            }
            if (!this.initFlags.search_date) {
                return
            }

            if (this.searchParam.search_type === 'CALLER_MDN' && this.searchParam.search_text.trim()) {
                this.searchParam.search_text = this.searchParam.search_text.replace(/\D/g, '')
            }

            this.$store.dispatch('svc_hist_svc/getStatList', {
                searchParam: this.searchParam,
                scb: () => {
                },
                fcb: (err) => {
                    console.log('error: svc_hist_svc/getStatList: ', err)
                },
                va: this
            })
        },
        openSvcCallListPopup(item) {
            console.log('openSvcCallListPopup() : ', item)
            this.$store.dispatch('svc_hist_svc/getSvcCallList', {
                searchParam: {
                    call_sid: item.call_sid,
                }, scb: (va) => {
                    va.dialogMode = 'svc_call_list'
                    va.modal = true
                }, fcb: (err) => {
                    console.log('openSvcCallListPopup() : ', err)
                },
                va: this
            })
        },
        closePopup() {
            this.modal = false
            this.dialogMode = 'none'
        },
        callResultText(c) {
            const statusMap = {'SUCC': '통화', 'MISS': '미응답', 'REJECT': '수신거부'}
            return statusMap[c] || c
        },
        transResultText(c) {
            if (!c) return ''
            if (c.trans_succ_yn === 'Y') return '통화'
            if (c.trans_try_yn === 'Y') return '실패'
            return '포기'
        },
        downloadRecord(item) {
            if (!item?.record_cont_seqno) return
            let va = this
            va.$store.dispatch('openConfirm', {
                message: '녹취 데이터를 다운로드 하시겠습니까?',
                va: va,
                okCb: function () {
                    svcHistApi.downloadRecord({seq: item.record_cont_seqno, tm: item.call_start_dt, mdn: item.caller_mdn}, err => {
                        console.log('err: ', err)
                        va.$store.dispatch('openAlert', {message: '다운로드 처리 중 오류가 발생하였습니다.'})
                    })
                }
            })
        },
        downloadExcel() {
            let va = this
            va.$store.dispatch('openConfirm', {
                message: '수신 통화 이력 목록을 엑셀 파일로 다운로드하시겠습니까?',
                va: va,
                okCb: function (va) {
                    va.excelLoading = true
                    svcHistApi.downloadSvcExcel({
                            search_start: va.searchParam.search_start,
                            search_end: va.searchParam.search_end,
                            trans_result: va.searchParam.trans_result,
                            search_type: va.searchParam.search_type,
                            search_text: va.searchParam.search_text,
                        },
                        (va) => {
                            va.excelLoading = false
                            // SUCC
                            va.$store.dispatch('openAlert', {message: '엑셀 파일이 다운로드 되었습니다',})
                        }, (err, va) => {
                            console.log(err)
                            va.excelLoading = false
                            // FAIL
                            va.$store.dispatch('openAlert', {message: '엑셀 파일이 다운로드를 실패 했습니다',})
                        }, va
                    )
                }
            })
        },
        popupAddrBook(custMdn) {
            this.$store.dispatch('openAddrBook',
                {
                    'addrBook': {
                        'cust_mdn': custMdn,
                        'pageMode': 'add_with_mdn'
                    },
                    'okCb': (va) => {
                        va.doSearch()
                    },
                    'va': this
                }
            )
        },
        popupCustMemo(item) {
            this.$emit('open-memo', {'cust_seqno': item.cust_seqno, 'cust_mdn': item.caller_mdn, 'cust_name': item.cust_name})
        },
        refresh() {
            this.doSearch()
        }
    }
}
</script>